import { render } from "./Contacted.vue?vue&type=template&id=6f41469c&scoped=true&lang=pug"
import script from "./Contacted.vue?vue&type=script&lang=js"
export * from "./Contacted.vue?vue&type=script&lang=js"

import "./Contacted.vue?vue&type=style&index=0&id=6f41469c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f41469c"]])

export default __exports__